<template>

  <div>
    <div class="saving" v-if="this.saving">
      <div class="loader"></div>
    </div>

    <router-view></router-view>
    <div class="holder" title="">


      <div class="navigation" title="">




        <div class="plan-item__title">Планировка помещения</div>

        <div class="plan-item-variants">

          <a class="plan-item-section plan-item-section--wall" href="#">Стены</a>
          <a class="plan-item-section plan-item-section--partition" href="#" @click.prevent="addPartition">Перегородки</a>
        </div>


        <div class="plan-item__title">Расстановка мебели</div>

        <div class="shelf-items">
          <div class="shelf-item" v-for="rack in rackprototypesTransformed" @dblclick="addRack(rack)">
            <div class="shelf-item__icon">
              <img src="/static/shelf-normal.png" width="16" alt=""/>
              <span class="shelf-item__rack-count">{{rack.shelfCount}}</span>
            </div>
            <div class="shelf-item__title">{{rack.title}} {{rack.width}}x{{rack.height}}x{{rack.depth}} мм</div>
            <router-link class="shelf-item__edit" :to="`/racks/${rack.id}/edit/`"></router-link>
          </div>
        </div>

      </div>

      <div class="editor-field"
           @mousemove="mousemove"
           @mouseup="mouseup"
           @mouseleave="mouseup"
           title=""
      >
        <div class="plan-holder" @click="planHolderClick" title="">
          <draggable-point v-for="(point, index) in draggablePoints"
                           @mousedown="mousedown"
                           @remove="remove"
                           :top="point.y"
                           :left="point.x"
                           :type="point.type"
                           :insertPos="point.insertPos"
                           :lineIndex="point.lineIndex"
                           :id="point.id"></draggable-point>

          <div class="added-racks">

            <rack-on-plan
                    v-for="(rack, key) in racks"
                    :width="rack.prototype.width"
                    :depth="rack.prototype.depth"
                    :left="rack.startX"
                    :top="rack.startY"
                    :angle="rack.angle"
                    :id="rack.id"
                    :title="rack.title"
                    :isExt="rack.isExt"
                    :sort="rack.sort ? rack.sort : 100"
                    @mousedown="mousedown"
                    v-on:contextmenu="contextmenu"
                    :selected="false"
                    @dblclick="removeRack(key)"
            ></rack-on-plan>
            <div  :style="angleBlock" class="angle-block" v-if="angleVisible">

              <div class="rack-on-plan__title">
                <input class="title-input" type="text" v-model="rackTitle" @click.stop="">
              </div>

              <div class="sort-and-ext">
                <div class="ext-config">
                  <label for="auto" class="label label--checkbox" @click.stop="">Выносной</label>
                  <input type="checkbox" class="checkbox" @click.stop="" name="selected-variant" id="auto" v-model="isExt">
                </div>

                <div class="sort-config">
                  <label for="auto" class="label label--checkbox" @click.stop="">Сортировка</label>
                  <input type="number" v-model.number="rackSort" @click.stop="" style="width: 50px">
                </div>
              </div>


              <div class="title-and-angle">


                <input type="range" min="0" max="360" step="5" v-model.number="angleValue">
                <div class="angle-block-value">{{angleValue}}˚</div>

              </div>




              <p class="copy-links">
                Скопировать
                <a href="#" @click.prevent="copyRackWithItems()">в эту же</a> или
                <a href="#" @click.prevent="copyRackWithItemsToOtherPharmacy()">в другую аптеку</a>
              </p>

            </div>


          </div>

          <svg>
            <g>
              <path :d="contour"></path>
              <path v-for="(partition, index) in partitions" :d="partition.str"></path>
            </g>
            <line v-for="line in guides" :x1="line.x1" :y1="line.y1" :x2="line.x2" :y2="line.y2" stroke="red" stroke-width="1" ></line>

            <g>
              <text  v-for="line in guides" :x="(line.x1 + line.x2) / 2 - 30" :y="(line.y1 + line.y2) / 2 - 20" >
                {{ Math.sqrt(Math.pow((line.x2 - line.x1), 2) + Math.pow((line.y2 - line.y1),2)  ) }} см
              </text>
            </g>
          </svg>

        </div>
      </div>

    </div>
  </div>



</template>


<script type="text/javascript">
  /* eslint-disable no-unused-vars,no-plusplus,arrow-body-style,
   no-empty,no-mixed-operators,no-nested-ternary, no-param-reassign,
   no-trailing-spaces, padded-blocks  */
  import Vue from 'vue';
  import axios from 'axios';

  const TYPE_DEF = 0;
  const TYPE_MIDDLE = 1;
  const TYPE_WALL = 2;
  const TYPE_RACK = 3;

  export default {
    name: 'pharmacy-edit',
    data() {
      return {
        title: '',
        rackSort: 100,
        isExt: false,
        angleValue: 0,
        angleVisible: false,
        initContourPoints: [
          { y: 40, x: 40, type: TYPE_DEF },
          { y: 40, x: 640, type: TYPE_DEF },
          { y: 400, x: 640, type: TYPE_DEF },
          { y: 400, x: 40, type: TYPE_DEF },
        ],
        guides: [],
        initPartitions: [
          [
            { x: 501, y: 67, type: TYPE_WALL },
            { x: 433, y: 241, type: TYPE_WALL },
          ],
        ],
        whatToMove: null,
        whatToRotate: null,
        rackprototypesTransformed: [],
        initRacks: [],
        rackTitle: '',
        saving: false,
      };
    },
    created() {
      const self = this;
      self.loadPharmacyInfo();
      self.loadPrototypes();
      this.$parent.$parent.$on('save', () => {
        self.save();
      });
    },
    destroyed() {
      this.$parent.$parent.$off('save');
    },
    methods: {
      loadPrototypes() {
        const self = this;
        axios.get('/api/v2/prototypes/').then((response) => {
          self.isLoading = false;
          self.makePrototypesList(response.data);
        });
      },
      loadPharmacyInfo() {
        const self = this;
        axios.get(`/api/v2/pharmacies/${this.$route.params.id}/`).then((response) => {
          self.isLoading = false;
          self.makePlan(response.data);
        });
      },
      makePlan(response) {
        if (response.contour !== null) {
          this.initContourPoints = response.contour;
        }
        if (response.walls !== null) {
          this.initPartitions = response.walls;
        }

        if (response.racks.length > 0) {
          this.initRacks = Object.assign(...response.racks.map(
            o => ({ [o.id]: Object.assign({}, o) }),
          ));
        } else {
          this.initRacks = {};
        }
      },
      makePrototypesList(response) {
        this.rackprototypesTransformed = Object.assign(...response.map(
          o => ({ [o.id]: Object.assign({}, o) }),
        ));
      },
      planHolderClick() {
        this.angleVisible = false;
      },

      copyRackWithItems() {

        const that = this;
        axios.post('/api/copyRack/', {
          rackId: this.whatToRotate.id,
          toId: this.$route.params.id,
          angle: this.whatToRotate.angle,
          startX: 0,
          startY: 0,
        }).then((answer) => {
          that.$set(this.initRacks, answer.data.id, {
            id: answer.data.id,
            startX: 0,
            startY: 0,
            angle: 0,
            title: this.whatToRotate.title,
             // eslint-disable-next-line max-len
            rackPrototype: Object.values(that.racks).filter(rack => rack.id === that.whatToRotate.id)[0].rackPrototype,
          });
        });
      },
      copyRackWithItemsToOtherPharmacy() {
        this.$router.push(`/pharmacies/${this.$route.params.id}/edit/copy/${this.whatToRotate.id}/`);
      },
      addRack(rack) {

        const newId = `newID${Object.keys(this.initRacks).length}`;
        this.$set(this.initRacks, newId, {
          id: newId,
          startX: 0,
          startY: 0,
          angle: 0,
          newly: true,
          title: rack.title,
          prototype: rack,
        });
      },
      removeRack(rack) {
        this.$delete(this.initRacks, rack);
      },

      remove(e) {
        if (e.type === TYPE_DEF) {
          this.initContourPoints.splice(e.id, 1);
        } else if (e.type === TYPE_WALL) {
          this.initPartitions.splice(e.lineIndex, 1);
        }
      },
      mousedown(e) {
        if (e.type === TYPE_MIDDLE) {
          this.initContourPoints.splice(e.insertPos, 0, { x: e.x, y: e.y, type: TYPE_DEF });
          e.id = e.insertPos;
        }
        this.whatToMove = e;
      },
      contextmenu(e) {
        this.whatToRotate = e;
        this.angleValue = e.angle;
        this.angleVisible = true;
        this.rackTitle = e.title;
        this.isExt = e.isExt ? e.isExt : false;
        this.rackSort = e.sort;

      },
      mousemove(e) {
        if (this.whatToMove !== null) {
          if (this.whatToMove.type === TYPE_RACK) {

            this.$set(this.initRacks[this.whatToMove.id], 'startX', e.clientX - this.whatToMove.offsetX);
            this.$set(this.initRacks[this.whatToMove.id], 'startY', e.clientY - this.whatToMove.offsetY);

            Object.values(this.initRacks).forEach((element) => {
              if (element.id !== this.whatToMove.id) {
                if (!e.shiftKey) {

                  if (Math.abs(this.initRacks[this.whatToMove.id].startY - element.startY) < 10) {
                    this.$set(this.initRacks[this.whatToMove.id], 'startY', element.startY);
                  }

                  if (Math.abs(this.initRacks[this.whatToMove.id].startX - element.startX) < 10) {
                    this.$set(this.initRacks[this.whatToMove.id], 'startX', element.startX);
                  }
                }

              }
            });

          } else if (this.whatToMove.type !== TYPE_WALL) {
            this.initContourPoints[this.whatToMove.id].y
              = e.clientY - this.whatToMove.offsetY;
            this.initContourPoints[this.whatToMove.id].x
              = e.clientX - this.whatToMove.offsetX;

            this.guides = [];
            this.initContourPoints.forEach((element) => {
              if (element.id !== this.whatToMove.id) {
                // snapping
                if (!e.shiftKey) {
                  if (Math.abs(this.initContourPoints[this.whatToMove.id].y - element.y) < 10) {
                    this.initContourPoints[this.whatToMove.id].y = element.y;
                  }

                  if (Math.abs(this.initContourPoints[this.whatToMove.id].x - element.x) < 10) {
                    this.initContourPoints[this.whatToMove.id].x = element.x;
                  }
                }

                // lines
                if (element.x === this.initContourPoints[this.whatToMove.id].x) {
                  this.guides.push(
                    {
                      x1: element.x,
                      y1: element.y,
                      x2: element.x,
                      y2: this.initContourPoints[this.whatToMove.id].y,
                    },
                  );
                }
                if (element.y === this.initContourPoints[this.whatToMove.id].y) {
                  this.guides.push(
                    {
                      x1: element.x,
                      y1: element.y,
                      x2: this.initContourPoints[this.whatToMove.id].x,
                      y2: element.y,
                    },
                  );
                }
              }
            });
          } else {
            const pointId = this.whatToMove.id % 1000;
            const lineId = (this.whatToMove.id - (pointId)) / 1000;

            this.initPartitions[lineId][pointId].y
              = e.clientY - this.whatToMove.offsetY;
            this.initPartitions[lineId][pointId].x
              = e.clientX - this.whatToMove.offsetX;

            this.guides = [];


            this.initPartitions[lineId].forEach((element) => {
              if (element.id !== this.whatToMove.id) {
                if (!e.shiftKey) {
                  if (Math.abs(this.initPartitions[lineId][pointId].y - element.y) < 10) {
                    this.initPartitions[lineId][pointId].y = element.y;
                  }

                  if (Math.abs(this.initPartitions[lineId][pointId].x - element.x) < 10) {
                    this.initPartitions[lineId][pointId].x = element.x;
                  }
                }

                if (element.x === this.initPartitions[lineId][pointId].x) {
                  this.guides.push(
                    {
                      x1: element.x,
                      y1: element.y,
                      x2: element.x,
                      y2: this.initPartitions[lineId][pointId].y,
                    },
                  );
                }
                if (element.y === this.initPartitions[lineId][pointId].y) {
                  this.guides.push(
                    {
                      x1: element.x,
                      y1: element.y,
                      x2: this.initPartitions[lineId][pointId].x,
                      y2: element.y,
                    },
                  );
                }
              }
            });

            this.initContourPoints.forEach((element) => {
              if (!e.shiftKey) {
                if (Math.abs(this.initPartitions[lineId][pointId].y - element.y) < 10) {
                  this.initPartitions[lineId][pointId].y = element.y;
                }

                if (Math.abs(this.initPartitions[lineId][pointId].x - element.x) < 10) {
                  this.initPartitions[lineId][pointId].x = element.x;
                }
              }
              // lines
              if (element.x === this.initPartitions[lineId][pointId].x) {
                this.guides.push(
                  {
                    x1: element.x,
                    y1: element.y,
                    x2: element.x,
                    y2: this.initPartitions[lineId][pointId].y,
                  },
                );
              }
              if (element.y === this.initPartitions[lineId][pointId].y) {
                this.guides.push(
                  {
                    x1: element.x,
                    y1: element.y,
                    x2: this.initPartitions[lineId][pointId].x,
                    y2: element.y,
                  },
                );
              }
            });
          }
        }
      },
      mouseup(e) {
        this.guides = [];
        this.whatToMove = null;
      },
      addPartition() {
        this.initPartitions.push([
          { x: 501, y: 67, type: TYPE_WALL },
          { x: 433, y: 241, type: TYPE_WALL },
        ]);
      },
      save() {

        this.saving = true;
        const racks = Object.values(this.initRacks).map((element) => {
          if (element.newly !== undefined && element.newly) {
            delete element.id;
          }
          element.rackPrototype = element.prototype.id;
          element.prototype = null;
          return element;
        });

        axios.patch(`/api/pharmacy/${this.$route.params.id}`, {
          walls: this.initPartitions,
          contour: this.initContourPoints,
          racks,
        }).then(() => {
          this.saving = false;
          window.location.reload();
        });
      },
    },
    computed: {
      /* eslint no-param-reassign: ["error",
       { "props": true, "ignorePropertyModificationsFor": ["point"] }] */
      draggablePoints() {
        const transformed = [];
        this.initContourPoints.forEach((point, index) => {
          point.id = index;
          transformed.push(point);
          const nextPoint = { type: TYPE_MIDDLE, insertPos: index + 1 };
          if (index < this.initContourPoints.length - 1) {
            nextPoint.x = point.x + (this.initContourPoints[index + 1].x - point.x) / 2;
            nextPoint.y = point.y + (this.initContourPoints[index + 1].y - point.y) / 2;
          } else {
            nextPoint.x = point.x + (this.initContourPoints[0].x - point.x) / 2;
            nextPoint.y = point.y + (this.initContourPoints[0].y - point.y) / 2;
          }
          transformed.push(nextPoint);
        });

        this.initPartitions.forEach((line, index) => {
          line.forEach((point, pointIndex) => {
            point.id = index * 1000 + pointIndex;
            point.lineIndex = index;
            transformed.push(point);
          });
        });
        return transformed;
      },
      contour() {
        const points = this.initContourPoints.map((stat, i) => {
          return `${i > 0 ? 'L' : ''} ${stat.x},${stat.y}`;
        }).join(' ');
        return `M ${points} Z`;
      },
      partitions() {
        return this.initPartitions.map((line) => {
          line.str = line.map((point, i) => {
            return `${i > 0 ? 'L' : ''} ${point.x},${point.y}`;
          }).join(' ');
          line.str = `M ${line.str}`;
          return line;
        });
      },
      racks() {
        return this.initRacks;
      },
      angleBlock() {
        return {
          top: `${this.whatToRotate ? this.whatToRotate.y : 0}px`,
          left: `${this.whatToRotate ? this.whatToRotate.x : 0}px`,
          position: 'absolute',
        };
      },
    },
    watch: {
      angleValue(input) {
        this.$set(this.initRacks[this.whatToRotate.id], 'angle', input);
      },
      rackTitle(input) {
        this.$set(this.initRacks[this.whatToRotate.id], 'title', input);
      },
      isExt(input) {
        this.$set(this.initRacks[this.whatToRotate.id], 'isExt', input);
      },
      rackSort(input) {
        this.$set(this.initRacks[this.whatToRotate.id], 'sort', input);
      },
    },
  };
</script>


<style lang="less" scoped>


  .angle-block {
    margin: 20px 0 0 -20px;
    padding: 20px;
    background: #FFFFFF;
    box-shadow: 5px 5px 23px 0 rgba(0,0,0,0.38);
  }



.navigation{
  padding: 76px 16px 16px;

}

  .plan-holder{
    position: relative;
    padding: 10px;
    margin-top: 50px;

    font-size: 14px;
  }

  .plan-item-variants{
    font-size: 0;
    margin: 0 -4px 30px;
  }

  .plan-item__title{
    font-weight: bold;
    font-size: 12px;
    color: #768791;
    line-height: 16px;
    text-transform: uppercase;
    margin-bottom: 8px;
  }

  .plan-item-section{
    width:64px;
    height:64px;
    display: inline-block;
    background: #fff center no-repeat;
    border-radius: 4px;
    font-size: 0;
    margin:0 4px;

    border: 1px solid #C4CBDF;


    &--active{
      border-color: transparent;
      background: #3F6FA7;
    }

    &--wall{
      background-image: url('/static/wall.svg');
    }

    &--partition{
      background-image: url('/static/partition.svg');
    }
  }

  .wall-point{
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #333;
    position: absolute;
    margin: -8px 0 0 -8px;
  }

  .shelf-item{
    position: relative;
    padding: 10px 0 15px;
    margin-bottom: 10px;

    &::after{
      position: absolute;
      content: "";
      bottom: 0;
      left: -5px;
      right: 0;
      height: 1px;
      background: rgba(48,86,131, 0.21);
    }

    &__rack-count{
      position: absolute;
      color: #000;
      font-size: 10px;
      border: 2px solid rgba(48,86,131, 0.71);
      border-radius: 50%;
      width: 24px;
      height: 24px;
      text-align: center;
      left: 7px;
      top: 0;
      background: #fff;
      font-weight: normal;
      line-height: 20px;
    }

    &__icon{
      display: inline-block;
      vertical-align: middle;
      width: 24px;
      margin-right: 16px;
    }
    &__title{
      font-size: 14px;
      display: inline-block;
      vertical-align: middle;
      width: 245px;
      cursor: pointer;
      margin-right: 5px;
    }

    &__edit{
      display: inline-block;
      vertical-align: middle;
      width: 26px;
      height: 26px;
      background: url("/static/baseline-edit-24px.svg");
      cursor: pointer;
    }
  }

  svg{
    width: 100%;
    height: 1000px;
  }

  path {
    stroke: #D3D3D4;
    stroke-width: 20px;
    fill: transparent;
  }


.rack-on-plan{
  border:1px solid #88929D;
  border-width: 1px 2px;
  box-sizing: border-box;
  position: absolute;

  &__title{
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
}

  .copy-links a{
    font-size: 11px;
    color: #96BBE6;
    text-decoration: none;
    text-transform: uppercase;
  }

  .ext-config{
    display: inline-block;
    margin-right: 20px;
    font-size: 12px;
  }

  .sort-config{
    display: inline-block;
    font-size: 12px;

    .label{
      margin-right: 10px;
    }
  }

  .sort-and-ext{
    font-size: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(48,86,131, 0.21);
    margin-bottom: 20px;

  }

  .title-input{
    width: 100%;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    font-weight: bold;
    font-size: 16px;
  }

  .saving {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ccc;
    z-index: 10000;
  }


  .loader {
    position: fixed;
    left: 50%;
    top: 50%;
    margin: -20em 0 0 -20em;
  }

</style>


// WEBPACK FOOTER //
// PharmacyEdit.vue?41b5285d